// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ePwen4NoZ4Q1QcvLNK2F {
  height: 100%;
  margin-bottom: 15px;
}

.fHJLcrdmX5NGWe9oERG9 {
  font-size: 23px;
  line-height: 120%;
  letter-spacing: 0.40px;
  font-weight: 760;
  margin: 15px 0;
  color: rgb(var(--placeholder-primary));
}

.dJDMmVhanKaGT7zcAYwx {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 7px;
  overflow: hidden;
}

.kpnZvgcGRvrJpFNkxR6C {
  position: relative;
  cursor: pointer;
}

.kpnZvgcGRvrJpFNkxR6C > img {
  border-radius: 30px;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.rFstkjpjdrhEFMNOxfRd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 7px;
  background: rgba(64, 69, 74, 0.24);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px); 
  width: max-content;
  border-radius: 22px;
  padding: 6px 10px;
  position: absolute;
  bottom: 20px;
  right: 50%;
  transform: translateX(50%);
}

.grn1WadVvead9dTHrJ45 {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-bottom: 10px;
}

.Y8ofZqPE5W3TrMOGp3Ac {
  border-radius: 16px;
  background: rgba(0, 122, 255, 0.10);
  padding: 14px 20px;
  color: #007AFF;
  font-weight: 510;
  line-height: 129%;
  letter-spacing: -0.43px;
  font-size: 17px;
  gap: 8px;
  height: auto;
}

.Y8ofZqPE5W3TrMOGp3Ac:hover {
  background: rgba(0, 122, 255, 0.10);
}

.CGZcnOIRs7pxhCD0ehCL {
  padding: 16px;
  border-radius: 24px;
  background: rgba(var(--secondary-bg), 0.40);
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px); 
  margin-bottom: 20px;
}

.hK0tHSGa8859uhhGtyNt {
  height: 10vh;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  font-size: 23px;
  font-weight: 540;
}`, "",{"version":3,"sources":["webpack://./src/pages/main/nft/nft.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".nftInner {\n  height: 100%;\n  margin-bottom: 15px;\n}\n\n.nftCollectionTitle {\n  font-size: 23px;\n  line-height: 120%;\n  letter-spacing: 0.40px;\n  font-weight: 760;\n  margin: 15px 0;\n  color: rgb(var(--placeholder-primary));\n}\n\n.nftCollectionItems {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 7px;\n  overflow: hidden;\n}\n\n.nftCollectionItem {\n  position: relative;\n  cursor: pointer;\n}\n\n.nftCollectionItem > img {\n  border-radius: 30px;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.nftCollectionItemInfo {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 7px;\n  background: rgba(64, 69, 74, 0.24);\n  backdrop-filter: blur(18px);\n  -webkit-backdrop-filter: blur(18px); \n  width: max-content;\n  border-radius: 22px;\n  padding: 6px 10px;\n  position: absolute;\n  bottom: 20px;\n  right: 50%;\n  transform: translateX(50%);\n}\n\n.pagination {\n  margin-top: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n  margin-bottom: 10px;\n}\n\n.actionButton {\n  border-radius: 16px;\n  background: rgba(0, 122, 255, 0.10);\n  padding: 14px 20px;\n  color: #007AFF;\n  font-weight: 510;\n  line-height: 129%;\n  letter-spacing: -0.43px;\n  font-size: 17px;\n  gap: 8px;\n  height: auto;\n}\n\n.actionButton:hover {\n  background: rgba(0, 122, 255, 0.10);\n}\n\n.emptyNftWrapper {\n  padding: 16px;\n  border-radius: 24px;\n  background: rgba(var(--secondary-bg), 0.40);\n  backdrop-filter: blur(40px);\n  -webkit-backdrop-filter: blur(40px); \n  margin-bottom: 20px;\n}\n\n.emptyNft {\n  height: 10vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  text-align: center;\n  font-size: 23px;\n  font-weight: 540;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nftInner": `ePwen4NoZ4Q1QcvLNK2F`,
	"nftCollectionTitle": `fHJLcrdmX5NGWe9oERG9`,
	"nftCollectionItems": `dJDMmVhanKaGT7zcAYwx`,
	"nftCollectionItem": `kpnZvgcGRvrJpFNkxR6C`,
	"nftCollectionItemInfo": `rFstkjpjdrhEFMNOxfRd`,
	"pagination": `grn1WadVvead9dTHrJ45`,
	"actionButton": `Y8ofZqPE5W3TrMOGp3Ac`,
	"emptyNftWrapper": `CGZcnOIRs7pxhCD0ehCL`,
	"emptyNft": `hK0tHSGa8859uhhGtyNt`
};
export default ___CSS_LOADER_EXPORT___;
